import { Star, Award, Heart } from "lucide-react";

export default function About() {
  return (
    <section
      id="over"
      className="relative py-24 sm:py-32 px-6 lg:px-10"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-tr from-mystic/30 via-gold/20 to-transparent blur-3xl" />
            <div className="relative glass rounded-3xl p-8 aspect-[4/5] overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_seppe-magic/artifacts/zzj18ul6__DSC2090.jpg"
                alt="Magic Seppe op het podium"
                className="w-full h-full object-cover rounded-2xl"
                data-testid="about-image"
              />
              <div className="absolute bottom-12 left-12 right-12 glass-strong rounded-xl p-4 flex items-center gap-3">
                <Star className="w-5 h-5 text-gold fill-gold" />
                <span className="text-sm text-[#F8F5FF]">Goochelt sinds 2020 · 100+ shows</span>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="text-xs uppercase tracking-[0.3em] text-gold mb-4" data-testid="about-eyebrow">
            — Maak kennis met Seppe
          </div>
          <h2
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight"
            data-testid="about-title"
          >
            Een wereld van <span className="gold-text italic">verwondering</span>,
            recht uit Dilsen-Stokkem.
          </h2>
          <p className="mt-6 text-lg text-[#B5A9C9] leading-relaxed" data-testid="about-intro">
            Ik ben Seppe — goochelaar en entertainer uit Dilsen-Stokkem. Sinds 2020
            breng ik magie naar kinderfeestjes, bedrijfsevents en buurtfeesten in
            België en Nederland, met ondertussen meer dan 100 shows op de teller.
          </p>
          <p className="mt-4 text-base text-[#B5A9C9] leading-relaxed" data-testid="about-story">
            Of het nu een grote podiumshow is, tafelgoochelen tussen de gasten of
            actieve circusanimatie met workshops en acts: elk optreden wordt op
            maat gemaakt om te verrassen, te verbluffen en vooral — te laten
            glimlachen.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-4">
            <Feature icon={Award} title="Op maat" desc="Show afgestemd op leeftijd & event" testid="about-feature-1" />
            <Feature icon={Heart} title="Interactief" desc="Publiek wordt actief betrokken" testid="about-feature-2" />
            <Feature icon={Star} title="Professioneel" desc="Eigen materiaal & geluid" testid="about-feature-3" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Feature({ icon: Icon, title, desc, testid }) {
  return (
    <div className="glass rounded-2xl p-5 hover:border-gold/40 transition-colors duration-300" data-testid={testid}>
      <Icon className="w-6 h-6 text-gold mb-3" />
      <div className="font-display text-lg font-semibold">{title}</div>
      <div className="text-sm text-[#B5A9C9] mt-1">{desc}</div>
    </div>
  );
}
